module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-500.84780596.woff2";